<template>
  <div class="document-container">
    <div class="doc-name">
      <p class="name">全局返回码说明</p>
      <p class="update-time">{{publicParams.updateTime}}</p>
    </div>
    <div class="request-module-box">
      <div class="module-text margin-top-20">
        <span>当接口请求失败时,会返回如下格式的json数据:</span>
      </div>
      <div class="code-example">
        <json-viewer :value="code"
                     :expand-depth="5"
                     boxed
                     copyable></json-viewer>
      </div>
      <div class="table-box">
        <table>
          <thead>
            <tr>
              <th class="t-w-50">错误码</th>
              <th class="t-w-50">说明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in errorCode"
                :key="index">
              <td>{{item.code}}</td>
              <td>{{item.value}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import Tables from "@/components/Tables";
import publicData from "@/api/public/index";
import errorCode from "@/api/public/error_code";
import { createOrderApi } from "@/api/order/index";
export default {
  components: {
    Tables
  },
  data() {
    return {
      publicParams: publicData,
      errorCode: errorCode,
      code: {
        code: 110010,
        msg: "请求体为空"
      }
    };
  }
};
</script>
<style lang="less" scoped>
.document-container {
  padding: 0 40px;
  text-align: left;
  .margin-top-20 {
    margin-top: 20px;
  }
  .doc-name {
    border-bottom: 1px solid #dedede;
    > .name {
      font-size: 24px;
      text-align: left;
      color: #333;
    }
    > .update-time {
      margin-top: 10px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #666666;
    }
  }
  .request-module-box {
    .module-name {
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .table-box {
      margin-top: 20px;
      table {
        border: 1px solid #dedede;
        width: 100%;
        th {
          height: 56px;
          line-height: 56px;
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          background-color: #fafafa;
          border: 1px solid #dedede;
        }
        .t-w-10 {
          width: 10%;
        }
        .t-w-15 {
          width: 15%;
        }
        .t-w-50 {
          width: 50%;
        }
        td {
          font-size: 14px;
          padding: 15px 15px;
          border: 1px solid #dedede;
        }
      }
    }
    .module-text {
      margin-bottom: 20px;
      font-size: 14px;
    }
    .code-example {
      background-color: #e8e8e8;
    }
  }
}
</style>